import { Injectable } from "@angular/core";
import { HttpService } from "../../services/http.service";
import { UtilityScripts } from "../../helpers/utility-scripts";
import { LocationVO } from "../vo/geo-location";
import { NotifierService } from "../../services/notifierService/notifier.service";
import { ConfigDocModelService } from "app/core/models/config-doc-model.service";
import { ScreenControllerService } from "app/core/controls/screen-controller.service";
import { CoursePage } from "app/core/vo/course-page";
import { AppServices } from "app/app.services";
import { DescriptorModelService } from "../../core/models/descriptor-model.service";

@Injectable()
export class StateSpecificContentModelService extends NotifierService {
	private stateSpecificContentXML: any;
	private selectedState: LocationVO;
	private selectedStateXML: any;
	private stateContentCollection: any[] = [];
	public bShowStateSpecificIcon: boolean = false;
	private showContentId: string = "";
	private bXMLLoaded: Boolean = false;
	public stateContent: any = {
		content: [],
		selected_state_id: "",
		selected_state_label: "",
		btn_text: "",
	};
	constructor(
		private httpService: HttpService,
		private configDocModel: ConfigDocModelService,
		private descriptorService: DescriptorModelService,
		private screencontroller: ScreenControllerService,
		private appService: AppServices
	) {
		super();
	}

	public initilize(xmlLoc, selectedLocation: LocationVO) {
		this.selectedState = selectedLocation;
		this.bShowStateSpecificIcon = false;
		this.stateContentCollection = [];
		this.loadXml(xmlLoc);
	}
	private loadXml(url) {
		this.httpService.getXmlData(url).then((res: any) => {
			this.stateSpecificContentXML = res;
			this.parseXML();
		});
	}
	private parseXML() {
		/*if (!UtilityScripts.isXML(this.stateSpecificContentXML)) {
          alert('StateSpecificContent XML contain errors, Please Check.');
      }*/
		this.selectedStateXML = this.getContentOfSelectedState();

		let headParams = Array.prototype.slice.call(
			this.stateSpecificContentXML.getElementsByTagName("parameter")
		);
		for (let element of headParams) {
			this.stateContentCollection[element.getAttribute("id")] = {
				id: element.getAttribute("id"),
				heading: element.textContent,
				content: this.selectedStateXML.getElementsByTagName(
					element.getAttribute("id")
				)[0]
					? this.selectedStateXML.getElementsByTagName(
							element.getAttribute("id")
					  )[0].textContent
					: "",
				visitedIcon: "false",
			};
		}
		this.bXMLLoaded = true;
		this._notifier.next("StateSpecificContentModelService parsed");
		if (this.showContentId != "") {
			this.overrideStateSpecificContent(true, this.showContentId);
			this.showContentId = "";
		}
	}
	private getContentOfSelectedState() {
		const arr = Array.prototype.slice.call(
			this.stateSpecificContentXML.getElementsByTagName("state")
		);
		if (arr.length === 1) {
			return arr[0];
		}
		/* To Be reviewed */
		if (this.selectedState === undefined) {
			return arr[0];
		}
		/*  */
		return arr.find(
			(content) =>
				content.getAttribute("id") === this.selectedState.id.toLowerCase()
		);
	}

	public updateStateContent(content_id, visit = null) {
		this.stateContent = this.getStateSpecificContent(content_id, visit);
	}

	public overrideStateSpecificContent(show, content_id) {
		if (show && !this.bXMLLoaded) {
			if (this.configDocModel.isStateSpecificContentPresent()) {
				this.showContentId = content_id;
				return;
			} else {
				this.appService.stateSpecificButtonClickHandler("");
			}
		}
		const pageInfo: CoursePage = this.screencontroller.coursePageVal;
		if (
			this.configDocModel.isStateSpecificContentPresent() &&
			pageInfo.state_specific_content !== "false" &&
			pageInfo.state_specific_content !== "" &&
			this.hasStateContent(content_id)
		) {
			this.bShowStateSpecificIcon = show;
			this.updateStateContent(content_id);
		} else {
			this.appService.stateSpecificButtonClickHandler("");
		}
	}

	public getStateSpecificContent(content_id, visit = null) {
		let stateData: any[] = [];
		if (this.stateContentCollection) {
			if (content_id.toLowerCase() === "true") {
				stateData = this.stateContentCollection;
			} else {
				const arr: string[] = content_id.split(",");
				arr.forEach((element) => {
					if (this.stateContentCollection[element]) {
						stateData.push(this.stateContentCollection[element]);
					}
				});
			}

			if (this.stateContentCollection[content_id].visitedIcon == "true")
				visit = "";

			/* visit = '_visited'; */

			/* let stateImage = this.stateImage;            
            if(visit)
            {   
                let imagePathArray = this.stateImage.split('/');
                let visitedImage = imagePathArray[imagePathArray.length-1].split('.');
                visitedImage[0]=visitedImage[0]+visit;
                imagePathArray[imagePathArray.length-1] = visitedImage.join('.');
                stateImage = imagePathArray.join('/');                
                this.stateContentCollection[content_id].visitedIcon='true';               
            }*/

			return {
				btn_text: this.descriptorService.getDescriptorTextById("stateClick"),
				content: stateData,
				selected_state_id: this.selectedState.id,
				selected_state_label: this.selectedState.label,
			};
		}
		return "";
	}
	private getStateContentByTagName(tagName) {
		return this.stateSpecificContentXML.getElementsByTagName(tagName)[0]
			.textContent;
	}
	public hasStateContent(state_id: string): Boolean {
		return (
			this.stateContentCollection &&
			this.stateContentCollection[state_id] &&
			this.stateContentCollection[state_id].content &&
			this.stateContentCollection[state_id].content !== ""
		);
	}
	public hideStateSpecificButon() {
		this.bShowStateSpecificIcon = false;
	}
}
